// Loader.jsx
import { Img } from "components/Img";
import React from "react";
import ReactDOM from "react-dom";

const loaderRoot = document.getElementById("root");

const Loader = () => {
    return ReactDOM.createPortal(
        <div className="fixed inset-0 flex items-center justify-center bg-[black] bg-opacity-50 z-50">
            <div className="bg-[white] rounded-full p-2">
                <Img
                    src="/images/loader.gif"
                    className="w-20 h-20"
                    alt="Loading"
                />
            </div>
        </div>,
        loaderRoot
    );
};

export default Loader;
